/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateMemoryStoreRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createMemoryStoreRequest: components.CreateMemoryStoreRequest;
};

/** @internal */
export const CreateMemoryStoreRequest$inboundSchema: z.ZodType<
  CreateMemoryStoreRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  CreateMemoryStoreRequest: components.CreateMemoryStoreRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateMemoryStoreRequest": "createMemoryStoreRequest",
  });
});
/** @internal */
export type CreateMemoryStoreRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  CreateMemoryStoreRequest: components.CreateMemoryStoreRequest$Outbound;
};

/** @internal */
export const CreateMemoryStoreRequest$outboundSchema: z.ZodType<
  CreateMemoryStoreRequest$Outbound,
  z.ZodTypeDef,
  CreateMemoryStoreRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  createMemoryStoreRequest: components.CreateMemoryStoreRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    createMemoryStoreRequest: "CreateMemoryStoreRequest",
  });
});

export function createMemoryStoreRequestToJSON(
  createMemoryStoreRequest: CreateMemoryStoreRequest,
): string {
  return JSON.stringify(
    CreateMemoryStoreRequest$outboundSchema.parse(createMemoryStoreRequest),
  );
}
export function createMemoryStoreRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateMemoryStoreRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateMemoryStoreRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateMemoryStoreRequest' from JSON`,
  );
}
